// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../szc.cycz.cc/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customer-table[data-v-1bcef330] {\n  width: 96%;\n  margin: auto;\n}", ""]);
// Exports
module.exports = exports;
